// eslint-disable-next-line import/prefer-default-export
export const FILE_TYPE_COPY = {
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/gif': 'GIF',
  'image/svg+xml': 'SVG',
  'image/tiff': 'TIFF',
  'image/webp': 'WEBP',
  'image/bmp': 'Bitmap',
};



// WEBPACK FOOTER //
// ./src/components/common/UploadcareWidget/widgetFileTypeCopy.js